<div *ngIf="value">
    <span class="badge bg-success me-2" *ngFor="let item of value.split(',')"> {{'paymentTypeValue.'+ item | translate}}</span>

</div>